const nepaliTxt={
    navigation:{
        home:'गृहपृष्ठ',
        introduction:'परिचय',
        program:"कार्यक्रम",
        report:"प्रतिबेदन",
        covid:"covid-data",
        notice:"सुचना तथा जानकारी"
    },
    name:{
        name:"ललितपुर महानगरपालिका"
        },
    OnlineRegistration:{
        onlineRegistration:"अनलाईन दर्ता गर्नुहोस",
        birthRegistration:"जन्म दर्ता ",
        marrageRegistration:"विवाह दर्ता",
        deathRegistration:"मृत्‍यु दर्ता",
        houseRegistration:"घर जग्गा दर्ता",
        migrationRegistration:"बसाईशाराई दर्ता"
    

    },
    covidUpdate:{
        heading:"नेपालमा कोरोनको अवस्था "

    }
}
export default nepaliTxt